import { SORT_OPTIONS } from "../constants/sortOptions";

const LABEL_KEY_BY_ID = Object.values(SORT_OPTIONS).reduce((acc, opt) => {
	acc[opt.id] = opt.labelKey;
	return acc;
}, {});

export const getSortLabelKey = sortId => {
	return LABEL_KEY_BY_ID[sortId] || sortId;
};
